import { styled } from '@mui/material/styles';

const StyledSecondaryFooter = styled('div')`
  padding: 1.5rem 2rem;
  text-align: center;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    text-align: left;
  }
`;

export default StyledSecondaryFooter;
